import React from "react";

const CustomLine = ({ className, circle }) => {
  return (
    <div
      className={`dark:bg-base-light-dark bg-base-light-white ${className} ${
        circle ? "rounded-full" : " rounded-[5px]"
      }`}
    ></div>
  );
};

export default CustomLine;
